<template>
    <div>
        <paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"
            @show="showModal = true">
        </paginated-search>

    </div>
</template>
<script>
import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
import CompanyBranch from "@/models/companyBranch.model.vue";
//import EspressoAux from "@/components/Espresso/EspressoAux.vue";
export default {
    components: {
        PaginatedSearch,
    },
    data() {
        return {
            company: {
                id: this.$route.params.id,
            },
            schema: CompanyBranch.getSchema(),            
        }
    },
    methods: {
        openEntity(entity) {
            this.$router.push(`/empresa/${this.company.id}/filial/${entity.id}`);
        },
        createEntity() {
            this.$router.push(`/empresa/${this.company.id}/filial/novo`);
        },
        searchEntities(paginationParameters) {
            paginationParameters.companyId = this.company.id;
            return CompanyBranch.search(paginationParameters);
        },
    }
}
</script>
<style scoped></style>